import { lang } from '../core/config'

export function formatCurrency(value, options = {}) {
    if ('round' in options) {
        value = Math.round(value/options.round) * options.round
        delete options.round
    }

    const thousands = Math.floor(value/1000)
    const num = value % 1000

    const total = []

    if (thousands > 0) {
        total.push(thousands)
    }

    total.push(num)

    if (lang === 'cs') {
        return `${total.join(' ')} Kč`
    } else {
        return `${total.join(' ')} CZK`
    }
}
